module.exports = __webpack_public_path__ + "static/media/speech_10.fd3c661e.svg";